<template>
  <div id="app">
    <loading :show="isLoading" :overlay="true" label="" :opacity="0">
      <template slot="loading-spinner">
        <Spinner></Spinner>
      </template>
    </loading>
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import loading from 'vue-full-loading';
import Spinner from '@/components/shared/spinner/Spinner';

export default {
  name: 'App',
  components: {
    loading,
    Spinner
  },
  computed: {
    ...mapGetters([
      'isLoading'
    ])
  }
};
</script>

<style lang="scss">
@import './stylesheets/main.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue